const DAYS = [
  { key: 'monday', label: 'Mon' },
  { key: 'tuesday', label: 'Tue' },
  { key: 'wednesday', label: 'Wed' },
  { key: 'thursday', label: 'Thu' },
  { key: 'friday', label: 'Fri' },
  { key: 'saturday', label: 'Sat' },
  { key: 'sunday', label: 'Sun' }
]

export function DayPicker({ selectedDays, onChange, error }) {
  const toggleDay = (day) => {
    if (selectedDays.includes(day)) {
      onChange(selectedDays.filter(d => d !== day))
    } else {
      onChange([...selectedDays, day])
    }
  }

  return (
    <div>
      <label className="block text-sm font-medium text-gray-700 mb-2">
        Days of Week {error && <span className="text-red-600 text-sm">*</span>}
      </label>
      <div className="grid grid-cols-7 gap-2">
        {DAYS.map(({ key, label }) => (
          <button
            key={key}
            type="button"
            onClick={() => toggleDay(key)}
            className={`
              py-2 px-1 text-sm font-medium rounded-lg transition-colors
              ${selectedDays.includes(key)
                ? 'bg-blue-600 text-white hover:bg-blue-700'
                : 'bg-white text-gray-700 border border-gray-300 hover:bg-gray-50'
              }
              ${error ? 'border-red-300' : ''}
            `}
          >
            {label}
          </button>
        ))}
      </div>
      {error && (
        <p className="mt-1 text-sm text-red-600">{error}</p>
      )}
      {selectedDays.length > 0 && !error && (
        <p className="mt-2 text-sm text-gray-500">
          Selected: {selectedDays.map(d => DAYS.find(day => day.key === d)?.label).join(', ')}
        </p>
      )}
    </div>
  )
}
